import { cn } from '@/lib/utils';

/** One fixed LTR lockup: a folded-photo monogram and the outlined editorial wordmark. */
export function Logo({ className, size = 'md', compact = false }: {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  compact?: boolean;
}) {
  return (
    <span dir="ltr" role="img" aria-label="freeAlbum" className={cn('inline-flex shrink-0 items-center', className)}>
      {compact ? <LogoMark className="sm:hidden" /> : null}
      <img src="/brand/logo.svg?v=3" alt="" aria-hidden draggable={false}
        className={cn('w-auto shrink-0', size === 'sm' ? 'h-8' : size === 'lg' ? 'h-12 sm:h-[4.5rem]' : 'h-10', compact && 'hidden sm:block')} />
    </span>
  );
}

export function LogoMark({ className }: { className?: string }) {
  return <img src="/brand/logo-mark.svg?v=3" width={64} height={64} alt="" aria-hidden draggable={false}
    className={cn('size-8 shrink-0 object-contain', className)} />;
}
